import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postAgent20 } from "./VipVipCommissionCRUD";
import { vipVipCommissionSlice } from "./VipVipCommissionSlice";

const { actions } = vipVipCommissionSlice;

export const clearVipVipCommissionList = () => (dispatch) => {
  dispatch(actions.vipVipCommissionListFetched({ data: null }));
};

export const fetchVipVipCommissionUI = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent20(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipVipCommissionUIFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipVipCommissionUI");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const fetchVipVipCommissionList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent20(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(
            actions.vipVipCommissionListFetched({ data: response.data })
          );
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipVipCommissionList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const fetchVipVipCommissionEffList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent20(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(
            actions.vipVipCommissionEffListFetched({ data: response.data })
          );
          return response;
        }
      } else {
        throw new Error("Error api: fetchVipVipCommissionEffList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const publishVipVipCommission = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return postAgent20(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.vipVipCommissionPublished());
          return response;
        }
      } else {
        throw new Error("Error api: publishVipVipCommission");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
